import { useQuery } from '@tanstack/react-query';

import { fetchGlobalClaimsApi } from './api';
import { GlobalClaimsParams } from './GlobalClaims.types';

/*
 * One page at a time, straight from GLOBAL. A page is kept for a minute so
 * going back and forth between pages does not ask again each time.
 */
export default function useGlobalClaimsQuery(params: GlobalClaimsParams) {
  return useQuery(['healthClaims', 'global', params], fetchGlobalClaimsApi, {
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
